module.exports = __webpack_public_path__ + "img/block2Img01.2597e0bc.png";